import React from 'react';
import ReactDOM from 'react-dom';
import styled, { css, keyframes } from 'styled-components';
import { LFC } from '../../../Legacy';
import { toRem } from './../../../ui';

const up = keyframes`
    from { transform: translateY(1rem); opacity: 0; }
    to { transform: translateY(0rem); opacity: 1; }
`;

const down = keyframes`
    from { transform: translateY(-1rem); opacity: 0; }
    to { transform: translateY(0rem); opacity: 1; }
`;

const left = keyframes`
    from { transform: translateX(1rem); opacity: 0; }
    to { transform: translateX(0rem); opacity: 1; }
`;

const right = keyframes`
    from { transform: translateX(-1rem); opacity: 0; }
    to { transform: translateX(0rem); opacity: 1; }
`;

export const PopperInner = styled.div<{ direction?: string, offset?: any }>`
    position: relative;
    ${p => p.direction === 'up' ? css`
        padding-bottom: ${toRem(p.offset ?? .25)};
        animation: ${up} 150ms cubic-bezier(0,.76,.47,1);
    ` : ''}
    ${p => p.direction === 'down' ? css`
        padding-top: ${toRem(p.offset ?? .25)};
        animation: ${down} 150ms cubic-bezier(0,.76,.47,1);
    ` : ''}
    ${p => p.direction === 'left' ? css`
        padding-right: ${toRem(p.offset ?? .25)};
        animation: ${left} 150ms cubic-bezier(0,.76,.47,1);
    ` : ''}
    ${p => p.direction === 'right' ? css`
        padding-left: ${toRem(p.offset ?? .25)};
        animation: ${right} 150ms cubic-bezier(0,.76,.47,1);
    ` : ''}
`;

export const PopperMount = styled.div`
    z-index: 100;
`;

export const PopperPortal: LFC = ({ children }) => <>
    {ReactDOM.createPortal(<div>{children}</div>, document.body)}
</>;

export const PopperToggle: LFC<{ open: boolean }> = ({ children, open }) => {

    // const [ref, setRef] = useState(null as HTMLDivElement);
    // const hidden = { opacity: 0, pointerEvents: 'none' as const };

    // return <div ref={setRef} style={!!ref && !open ? hidden : {}}>
    //     {(!ref || open) && <>{children}</>}
    // </div>;

    return <>{open && <>{children}</>}</>;
};
